import { Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import Modal from '../../../components/common/Modal';
import React from 'react';

type EditNameModalProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  firstName: string;
  setFirstName: (value: string) => void;
  lastName: string;
  setLastName: (value: string) => void;
  onUpdate: () => void;
};

export default function EditNameModal(props: EditNameModalProps) {
  return (
    <Modal title={'Edit User Name'} open={props.open} setOpen={props.setOpen}>
      <Grid container spacing={2} paddingTop={2}>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              label='First Name'
              variant='outlined'
              value={props.firstName}
              onChange={e => props.setFirstName(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <TextField
              label='Last Name'
              variant='outlined'
              value={props.lastName}
              onChange={e => props.setLastName(e.target.value)}
            />
          </FormControl>
        </Grid>
        <Grid item>
          <Button onClick={props.onUpdate}>Update user</Button>
        </Grid>
      </Grid>
    </Modal>
  );
}
